import React from "react";
import StandardReportCard from "../pages/Admin/ReportCardTemplates/standard";
import GJBWReportCard from "../pages/Admin/ReportCardTemplates/gj-bw";

// ─────────────────────────────────────────────────────────
// ReportCard — Template Switcher
// ─────────────────────────────────────────────────────────
// Automatically selects the template based on instituteInfo.reportCardTemplate
// (e.g. "gj-bw" or "standard"), falling back to props.template or "standard".
// All other props are forwarded to the selected template component.
// ─────────────────────────────────────────────────────────

const TEMPLATES = {
  standard: StandardReportCard,
  "gj-bw": GJBWReportCard,
};

const ReportCard = ({ template, ...props }) => {
  const selectedTemplate =
    props.instituteInfo?.reportCardTemplate ||
    template ||
    "standard";

  const TemplateComponent =
    TEMPLATES[selectedTemplate] || StandardReportCard;

  return <TemplateComponent {...props} />;
};

export default ReportCard;
